import React from 'react';
import { SectionCta } from './SectionCta';
import { IMAGES } from '../data/content';
const learned = ['They learn protocols.', 'They learn techniques.', 'They learn anatomy.', 'They learn how procedures are supposed to go.'];
const realCases = ['Sometimes the anatomy is different.', "Sometimes the resistance isn't what you expected.", "Sometimes the surgical field gives you information you didn't have when you made the original plan.", 'Sometimes a seemingly small finding deserves more attention.'];
export function About() {
  return <section className="bg-canvas px-5 py-16 sm:py-24" aria-labelledby="about-title" data-id="element-20" data-mp="38o8bkvbbzw7t">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:items-start" data-id="element-21" data-mp="3dhuq6t122a69">
        <div className="md:sticky md:top-8" data-id="element-22" data-mp="3hkr6gd34hu71">
          <img src={IMAGES.author} alt="Dr. Michael Carter" className="aspect-[4/5] w-full rounded-3xl object-cover object-top" loading="lazy" data-id="element-23" data-mp="3miiv8y8h1070" />
          <p className="mt-4 text-center font-display text-2xl font-bold uppercase text-navy-900" data-id="element-24" data-mp="2lrh65nfp215h">Dr. Michael Carter</p>
          <p className="text-center text-sm font-semibold uppercase tracking-wider text-radar-deep" data-id="element-25" data-mp="2gqktolha16og">
            Creator of Implant Risk Radar™
          </p>
        </div>

        <div data-id="element-26" data-mp="27s7t2wmsbn5q">
          <p className="text-sm font-bold uppercase tracking-widest text-radar-deep" data-id="element-27" data-mp="27shhifs6lm9b">About Dr. Michael Carter</p>
          <h2 id="about-title" className="mt-2 font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-28" data-mp="34h72iez3uuzi">
            Why I created Implant Risk Radar™
          </h2>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-29" data-mp="2vn23h89tid8w">
            <p data-id="element-30" data-mp="2qq1xsygvrcib">
              I'm Dr. Michael Carter, and over the years I've seen the same pattern repeatedly: dentists study
              implantology.
            </p>
            <ul className="space-y-1 pl-5 text-muted [list-style:disc]" data-id="element-31" data-mp="3jdy3gsofger8">
              {learned.map(l => <li key={l} data-id="element-32" data-mp="6751ch4o1m7k">{l}</li>)}
            </ul>
            <p data-id="element-33" data-mp="b5gbksyvhyqb">But there's another skill that doesn't always get enough attention:</p>
            <p className="border-l-4 border-radar pl-4 text-xl font-semibold text-navy-900" data-id="element-34" data-mp="3tj62tyi8c34y">
              Knowing what to notice when the procedure doesn't go exactly as expected.
            </p>
            <p data-id="element-35" data-mp="3jkqeg3al77z5">Because real clinical cases don't always follow the textbook.</p>
            <ul className="space-y-1 pl-5 text-muted [list-style:disc]" data-id="element-36" data-mp="3jn32my6xuekn">
              {realCases.map(l => <li key={l} data-id="element-37" data-mp="3ak1y31xq0vj3">{l}</li>)}
            </ul>
            <p data-id="element-38" data-mp="3alv36csor7oz">
              And in those moments, having more information isn't necessarily the answer. Having a structured way to
              process what you're seeing can be far more useful.
            </p>
            <p data-id="element-39" data-mp="18qkuqagmigu5">
              Not as another lengthy implantology course. Not as a collection of scary complication stories. And
              definitely not as a substitute for clinical training, professional judgment, or appropriate specialist
              support.
            </p>
            <p data-id="element-40" data-mp="2tckgmmtd7azs">
              I created it as a practical reference system to help you recognize potential warning signals, organize
              your reassessment, and become more deliberate about the decisions surrounding difficult implant cases.
            </p>
            <p className="font-semibold text-navy-900" data-id="element-41" data-mp="3gz955rcvq1pd">
              Because I don't believe the goal is to eliminate every unexpected event. The goal is to become better at
              recognizing when something deserves your attention.
            </p>
            <p className="font-display text-xl font-semibold uppercase text-navy-900" data-id="element-42" data-mp="3l1w0w3co86ru">— Dr. Michael Carter</p>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl" data-id="element-43" data-mp="1vnqvwow3tutl">
        <SectionCta label="I want Dr. Carter's system" data-id="element-44" data-mp="1vosinqmhg5r5" />
      </div>
    </section>;
}